/**
 * Safe internal returnTo helpers for legal pages.
 */

export function isSafeInternalReturnTo(value) {
  if (!value || typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return false;
  if (trimmed.startsWith("//")) return false;
  if (trimmed.includes("://")) return false;
  if (/[\s\\]/.test(trimmed)) return false;
  return true;
}

export function resolveSafeReturnTo(value, fallback = null) {
  return isSafeInternalReturnTo(value) ? value.trim() : fallback;
}

/**
 * Minimal markdown → safe React-friendly HTML (no raw scripts).
 * Escapes HTML first, then applies a small set of markdown rules.
 */
export function renderLegalMarkdownToSafeHtml(markdown) {
  const raw = String(markdown || "");
  const escaped = raw
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

  const withBlocks = escaped
    .replace(/^### (.+)$/gm, "<h3>$1</h3>")
    .replace(/^## (.+)$/gm, "<h2>$1</h2>")
    .replace(/^# (.+)$/gm, "<h1>$1</h1>")
    .replace(/^&gt; (.+)$/gm, "<blockquote>$1</blockquote>")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\n{2,}/g, "</p><p>")
    .replace(/\n/g, "<br />");

  return `<p>${withBlocks}</p>`;
}
